import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { formatApiErrorDetail } from "../lib/api";
import { Loader2, Hospital } from "lucide-react";

export default function StrutturaLogin() {
  const { login, logout } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const u = await login(form.email, form.password);
      if (u.role !== "struttura") {
        await logout();
        setError("Questo accesso è riservato alle Strutture Sanitarie. Usa la pagina di login della Centrale Operativa.");
        return;
      }
      navigate("/strutture");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-nexus-blue p-6 relative overflow-hidden">
      <div className="absolute -top-32 -right-32 h-96 w-96 rounded-full bg-nexus-gold/10 blur-3xl" />
      <div className="relative w-full max-w-md bg-white rounded-xl shadow-xl p-8 nx-fade-in border-t-4 border-nexus-gold">
        <div className="flex justify-center mb-6"><img src="/nexus_logo.png" alt="Nexus Italia Group" className="h-16 w-auto object-contain" /></div>
        <p className="flex items-center justify-center gap-2 nx-label text-primary mb-1"><Hospital className="h-4 w-4" /> Portale Strutture Sanitarie</p>
        <h1 className="text-2xl font-bold font-heading text-slate-900 text-center mb-1">NexusOmniaCare</h1>
        <p className="text-sm text-slate-500 text-center mb-6">Inserisci le richieste di trasporto e seguine lo stato.</p>
        {error && <div data-testid="portal-login-error" className="mb-4 rounded-md bg-red-50 border border-red-200 px-4 py-2.5 text-sm text-red-700">{error}</div>}
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label className="nx-label">Email</Label>
            <Input data-testid="portal-login-email" type="email" required className="mt-1.5" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
          </div>
          <div>
            <Label className="nx-label">Password</Label>
            <Input data-testid="portal-login-password" type="password" required className="mt-1.5" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
          </div>
          <Button data-testid="portal-login-submit" type="submit" disabled={loading} className="w-full">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Accedi al portale"}
          </Button>
        </form>
        <p className="text-xs text-slate-400 text-center mt-6">Le credenziali sono fornite dalla Centrale Operativa Nexus Italia Group.</p>
      </div>
    </div>
  );
}
